import { firebaseAuth } from "@/infrastructure/firebase";
import { RootState } from "@/infrastructure/rootState";
import { AppAction } from "@/features/applications";
import { TitleCase } from "@/utils/string";

import { Layout, Breadcrumb, Menu, Dropdown, Row, Col } from "antd";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import styles from "./styles.less";

export default () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const history = useHistory();
  const pathCollections = pathname === "/" ? [""] : pathname.split("/");
  const { isSuperuser, loading } = useSelector(({ app: { userInfo, loading } }: RootState) => ({
    isSuperuser: userInfo.isSuperuser,
    loading: loading.userInfo === "REQUEST"
  }));

  const menu =
    pathCollections.length > 4 ? (
      <Menu>
        <Menu.Item key="base">
          {pathCollections[1] === "storyboard" ? "OAA" : TitleCase(pathCollections[1].replace("-", " "))}
        </Menu.Item>
        <Menu.Divider />
        {pathCollections.slice(2, pathCollections.length - 2).map((path, i) => (
          <Menu.Item key={i}>
            <Link to={pathCollections.slice(0, i + 3).join("/")}> / {TitleCase(path.replace("-", " "))}</Link>
          </Menu.Item>
        ))}
      </Menu>
    ) : <></>;

  return (
    <Layout.Header className={styles.header}>
      <Row justify="space-between">
        <Col>
          <Breadcrumb separator=">" style={{ display: "inline-block" }}>
            {pathCollections.map((path, i) => pathToLongBreadCrumb(path, i))}
          </Breadcrumb>
        </Col>
        <Col>
          {!loading && !isSuperuser ? (
            <Button variant="contained" color="default" startIcon={<FingerprintIcon />}>
              <Link to="/login">Login</Link>
            </Button>
          ) : (
            <Button variant="contained" color="default" startIcon={<ExitToAppIcon />} onClick={() => logout()}>
              Logout
            </Button>
          )}
        </Col>
      </Row>
    </Layout.Header>
  );

  function logout() {
    history.push("/login");
    firebaseAuth.signOut().then(() => {
      history.push("/login");
    });
    dispatch(
      AppAction.updateUserInfo({
        username: "",
        userId: "",
        email: "",
        watchlist: {},
        isSuperuser: false
      })
    );
  }

  function pathToBreadcrumb(path: string, index: number) {
    if (path === "") {
      return (
        <Breadcrumb.Item key={index}>
          <Link to="/">Home</Link>
        </Breadcrumb.Item>
      );
    } else if (path === "storyboard") {
      return <Breadcrumb.Item key={index}>Storyboard</Breadcrumb.Item>;
    } else {
      return (
        <Breadcrumb.Item key={index}>
          <Link to={pathCollections.slice(0, index + 1).join("/")}>{TitleCase(path.replace(/-/g, " "))}</Link>
        </Breadcrumb.Item>
      );
    }
  }

  function pathToLongBreadCrumb(path: string, index: number) {
    if (pathCollections.length > 4 && index !== 0 && index < pathCollections.length - 2) {
      return index === 1 ? (
        <Breadcrumb.Item key={index}>
          <Dropdown overlay={menu} trigger={["click"]} placement="bottomCenter">
            <a className="ant-dropdown-link" href="#">
              ...
            </a>
          </Dropdown>
        </Breadcrumb.Item>
      ) : null;
    }
    return pathToBreadcrumb(path, index);
  }
};
